"use strict";
'use client';
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBrand = void 0;
var apps_shared_1 = require("@l2p/apps-shared");
var react_1 = require("react");
var useConfig_1 = require("../useConfig");
var useBrand = function () {
    var _a = (0, react_1.useState)(false), mounted = _a[0], setMounted = _a[1];
    var config = (0, useConfig_1.useConfig)();
    var appName = config === null || config === void 0 ? void 0 : config['appName'];
    (0, react_1.useEffect)(function () {
        setMounted(true);
        return function () { return setMounted(false); };
    }, []);
    return (0, react_1.useMemo)(function () {
        var _a;
        var brand = '';
        var website = '';
        if (mounted) {
            var host = typeof window !== 'undefined' ? (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.host : '';
            var result = (0, apps_shared_1.getBrandAndWebsiteFromOrigin)({ host: host });
            brand = appName ? appName : result === null || result === void 0 ? void 0 : result.brand;
            website = result === null || result === void 0 ? void 0 : result.website;
        }
        return { brand: brand, website: website };
    }, [appName, mounted]);
};
exports.useBrand = useBrand;
